import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { ApiStatus } from "../../utils/api.types";
import { fetchGstOptions, fetchTaxRates } from "./gstThunk";
import { IGstSliceState } from "../../utils/gst.types";

/**
 * State slice initial state.
 */
const initialState: IGstSliceState = {
    gsts: [],
    taxRates: [],
    status: ApiStatus.IDLE,
    errorMessage: ''
}

/**
 * State Slice.
 */
const gstSlice = createSlice({
    name: 'state',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch countries
            .addCase(fetchGstOptions.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchGstOptions.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.gsts = action.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchGstOptions.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })     
            // Fetch tax rates
            .addCase(fetchTaxRates.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchTaxRates.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.taxRates = action.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchTaxRates.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })     
    }
});

export default gstSlice.reducer;
